import { addDoubleQuotes, addQuotes } from '../utils/smartutils';
import {
  TEMPLATE_APPLICATION_TYPE,
  TEMPLATE_TYPE_COMU,
  TEMPLATE_TYPE_OCCU,
} from '../utils/constants';

export function memoTemplateListAllByApplicationType(applicationType) {
  return `{
  memoTemplateListByFilter(
    filter: {
      id: 0
      active: true
      filterByStatus: false
      updaterId: 0
      name: ""
      description: ""
      defaultTitle: ""
      defaultBody: ""
      applicationType: ${addQuotes(applicationType)}
    }
  ) {
    id
    name
    active
  }
}`;
}

export function memoTemplateById(id, type) {
  let applicationType;
  switch (type) {
    case TEMPLATE_TYPE_COMU:
      applicationType = TEMPLATE_APPLICATION_TYPE.COMU;
      break;
    case TEMPLATE_TYPE_OCCU:
      applicationType = TEMPLATE_APPLICATION_TYPE.OCCU;
      break;
    default:
  }
  return `{
  memoTemplateListByFilter(
    filter: {
      id: ${id}
      active: true
      filterByStatus: false
      updaterId: 0
      name: ""
      description: ""
      defaultTitle: ""
      defaultBody: ""
      applicationType: ${addQuotes(applicationType)}
    }
  ) {
    id
    name
    active
    description
    defaultTitle
    defaultBody
    defaultBodyInHTML
    applicationType
  }
}`;
}

export function saveMemoTemplateMutation(type, values) {
  let templateType;
  switch (type) {
    case TEMPLATE_TYPE_COMU:
      templateType = TEMPLATE_APPLICATION_TYPE.COMU;
      break;
    case TEMPLATE_TYPE_OCCU:
      templateType = TEMPLATE_APPLICATION_TYPE.OCCU;
      break;
    default:
  }

  const mutationQuery = `mutation($defaultBodyInHTML: String!, $defaultBody: String!, $defaultTitle: String!) {
         memoTemplateSave(
           memoTemplate: {id: ${values.id ? values.id : 0}
             applicationType: ${addQuotes(
               values.applicationType || templateType
             )}
             name: "${values.name}"
             description: ${
               values.description
                 ? addDoubleQuotes(values.description)
                 : addQuotes()
             }
             defaultTitle: $defaultTitle  
             defaultBody: $defaultBody
             defaultBodyInHTML: $defaultBodyInHTML
             active: ${values.active}
             filterByStatus: false                                        
             updaterId: 0                                        
          }
        ),
    {id}
  }`;
  return mutationQuery;
}

export function removeMemoTemplateMutation(id) {
  return `mutation{memoTemplateRemove(id: ${id})}`;
}

export function memoTemplateListOnlyActiveByApplicationType(applicationType) {
  return `{
  memoTemplateListByFilter(
    filter: {
      id: 0
      active: true
      filterByStatus: true
      updaterId: 0
      name: ""
      description: ""
      defaultTitle: ""
      defaultBody: ""
      applicationType: ${addQuotes(applicationType)}
    }
  ) {
    id
    name
    description
    defaultTitle
    defaultBody
    defaultBodyInHTML
    applicationType
  }
}`;
}
